import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { TermsOfUseComponent } from '../../modal-content/terms-of-use/terms-of-use.component';
import { MatDialog } from '@angular/material/dialog';
import { DsGeneralNavItem } from '@esolutions/design-system-ng/models';
import { SimpleFooterComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [SimpleFooterComponent],
  standalone: true
})
export class FooterComponent implements OnInit, AfterViewInit {
  popup = false;
  message: string;
  links: DsGeneralNavItem[];

  @Input()
  public delay = 0;

  private matDialog = inject(MatDialog);

  constructor() {
    this.message =
      'We acknowledge the Traditional Custodians of the unceded lands and waterways on which Deakin University does business. We pay our deep respect to the Ancestors and Elders of Wadawurrung Country, Eastern Maar Country and Wurundjeri Country where our physical campuses are located. We also acknowledge all First Nations Peoples that make contributions to our learning communities.';
    this.links = [
      {
        text: 'Copyright',
        route: 'https://www.deakin.edu.au/copyright'
      },
      {
        text: 'Disclaimer',
        route: 'https://www.deakin.edu.au/web-disclaimer'
      },
      {
        text: 'Privacy',
        route: 'https://www.deakin.edu.au/footer/privacy'
      },
      {
        text: 'Terms of Use',
        route: 'terms-of-use'
      }
    ];
  }

  ngAfterViewInit() {
    const widget = document.querySelector('ds-simple-footer') as HTMLElement;
    const shadowRoot = (widget as any).shadowRoot;

    if (shadowRoot) {
      const links = shadowRoot.querySelectorAll('li');
      if (links.length > 0) {
        const lastLink = links[links.length - 1];

        lastLink?.addEventListener('contextmenu', (e) => e.preventDefault());
        lastLink
          .querySelector('a')
          ?.addEventListener('contextmenu', (e) => e.preventDefault());
      }
    }
  }

  ngOnInit() {
    if (this.delay > 0) {
      setTimeout(() => {
        this.delay = 0;
      }, this.delay);
    }
  }

  openTermsModal() {
    this.matDialog.open(TermsOfUseComponent, {
      autoFocus: false,
      width: '528px',
      maxHeight: '100vh',
      panelClass: 'custom-dialog-container'
    });
  }

  selectedLink(url: string) {
    if (url.includes('terms-of-use')) {
      this.openTermsModal();
    } else {
      window.open(url, '_blank');
    }
  }
}
